// src/shared/bookmarksToExclude.js
const excludedBookmarks = [
    "51b55f7a-a837-42e9-91fe-197fe8faeda2",
    "044e2a80-0a06-4bbe-afcb-d06f390159d9",
    "a3dfd0cd-e260-4700-b6cf-44735036300d",
    "06869c5f-d466-4a48-ae46-967b7fb8d55f",
    "9cfe0aa5-48ff-4afd-83db-99e5f121a950",
    "650a1fdc-712c-41c6-8fee-abb26b7f4023",
  ];
  
  export default excludedBookmarks;
  